import React from "react";
import { Button, Box } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";

interface ExportImportButtonsProps {
  onExport: () => void;
  onImport?: () => void;
  exportLabel?: string;
  importLabel?: string;
  disabledExport?: boolean;
  disabledImport?: boolean;
}

const ExportImportButtons: React.FC<ExportImportButtonsProps> = ({
  onExport,
  onImport,
  exportLabel = "Export",
  importLabel = "Import",
  disabledExport = false,
  disabledImport = false,
}) => (
  <Box sx={{ display: "flex", gap: 2 }}>
    <Button
      variant="contained"
      sx={{
        backgroundColor: "#e6e6fa", // light purple
        color: "#6c2eb7", // purple text
        boxShadow: "none",
        '&:hover': {
          backgroundColor: "#6c2eb7", // dark purple on hover
          color: "#fff",
        },
        textTransform: "none",
        fontWeight: "bold",
        borderRadius: 2,
        minWidth: 100,
      }}
      startIcon={<FileDownloadIcon />}
      onClick={onExport}
      disabled={disabledExport}
    >
      {exportLabel}
    </Button>
    <Button
      variant="contained"
      sx={{
        backgroundColor: "#d4edda", // light green
        color: "#218838", // green text
        boxShadow: "none",
        '&:hover': {
          backgroundColor: "#218838", // dark green on hover
          color: "#fff",
        },
        textTransform: "none",
        fontWeight: "bold",
        borderRadius: 2,
        minWidth: 100,
      }}
      startIcon={<FileUploadIcon />}
      onClick={onImport}
      disabled={disabledImport}
    >
      {importLabel}
    </Button>
  </Box>
);

export default ExportImportButtons;
